{
  "header": {
    "nav": {
      "solutions": "Soluciones",
      "developers": "Desarrolladores",
      "contact": "Contacto"
    },
    "signIn": "Iniciar sesión",
    "getStarted": "Comenzar",
    "goToDashboard": "Ir al panel",
    "openMenu": "Abrir menú principal"
  },
  "hero": {
    "title": "Gestione su negocio de servicios",
    "titleHighlight": "sin esfuerzo",
    "subtitle": "La plataforma todo en uno para programar citas, gestionar clientes, hacer seguimiento de ingresos y hacer crecer su negocio de servicios. Comience gratis, escale fácilmente.",
    "startTrial": "Iniciar prueba gratuita",
    "seeHowItWorks": "Ver cómo funciona"
  },
  "features": {
    "title": "Todo lo que necesita para tener éxito",
    "subtitle": "Funciones potentes diseñadas para ayudarle a ahorrar tiempo, aumentar ingresos y ofrecer experiencias excepcionales a sus clientes.",
    "items": {
      "scheduling": {
        "name": "Programación inteligente",
        "description": "Programación inteligente de citas que reduce las ausencias y maximiza la eficiencia de su calendario."
      },
      "customers": {
        "name": "Gestión de clientes",
        "description": "Lleve un registro del historial, preferencias e interacciones de sus clientes en un solo lugar centralizado."
      },
      "analytics": {
        "name": "Panel de analítica",
        "description": "Obtenga información sobre el rendimiento de su negocio con analítica e informes en tiempo real."
      },
      "payments": {
        "name": "Procesamiento de pagos",
        "description": "Acepte pagos sin complicaciones con procesamiento de pagos e facturación integrados."
      },
      "reminders": {
        "name": "Recordatorios automatizados",
        "description": "Reduzca las ausencias con recordatorios automatizados por correo y SMS para las citas."
      },
      "security": {
        "name": "Seguro y confiable",
        "description": "Seguridad de nivel empresarial con garantía de disponibilidad del 99,9% para su tranquilidad."
      },
      "mobile": {
        "name": "Listo para móvil",
        "description": "Gestione su negocio en movimiento con nuestra experiencia móvil totalmente adaptable."
      },
      "booking": {
        "name": "Reservas en línea",
        "description": "Permita que los clientes reserven citas en línea las 24 horas del día a través de su página de reservas personalizada."
      }
    }
  },
  "testimonials": {
    "title": "Amado por negocios en todas partes",
    "subtitle": "Vea lo que nuestros clientes dicen sobre su experiencia con Woezor.",
    "items": {
      "sarah": {
        "content": "Woezor ha transformado la forma en que gestionamos las citas. ¡Nuestra tasa de ausencias bajó un 60% en el primer mes!",
        "role": "Propietaria, Serenity Spa"
      },
      "michael": {
        "content": "El panel de analítica me da información que nunca tuve antes. Por fin puedo tomar decisiones basadas en datos para mi clínica.",
        "role": "Director, Family Health Clinic"
      },
      "emily": {
        "content": "La configuración fue increíblemente fácil. En un día teníamos las reservas en línea funcionando y los clientes ya estaban programando citas.",
        "role": "Gerente, Elite Fitness Studio"
      },
      "james": {
        "content": "El soporte al cliente es excepcional. Nos ayudaron a personalizar todo para adaptarlo a nuestro flujo de trabajo único.",
        "role": "Fundador, Wilson Consulting"
      },
      "lisa": {
        "content": "Hemos aumentado nuestras reservas un 40% desde que cambiamos a Woezor. El retorno de la inversión ha sido increíble.",
        "role": "Propietaria, Park Beauty Lounge"
      },
      "david": {
        "content": "Por fin, un sistema de programación que realmente funciona para negocios de servicios. ¡Muy recomendable!",
        "role": "CEO, Thompson Home Services"
      }
    }
  },
  "cta": {
    "title": "¿Listo para transformar su negocio?",
    "subtitle": "Únase a miles de negocios de servicios que confían en Woezor para gestionar sus citas, clientes y crecimiento. Inicie su prueba gratuita hoy.",
    "getStarted": "Comenzar gratis",
    "talkToSales": "Hablar con ventas",
    "benefits": {
      "trial": "Prueba gratuita de 14 días",
      "noCard": "No se requiere tarjeta de crédito",
      "cancel": "Cancele en cualquier momento"
    }
  },
  "footer": {
    "company": "Empresa",
    "product": "Producto",
    "legal": "Legal",
    "connect": "Conectar",
    "about": "Acerca de",
    "contact": "Contacto",
    "features": "Funciones",
    "pricing": "Precios",
    "privacy": "Política de privacidad",
    "terms": "Términos de servicio",
    "twitter": "Twitter",
    "linkedin": "LinkedIn",
    "copyright": "© {{year}} ForumOne. Todos los derechos reservados."
  },
  "solutions": {
    "heroTitle": "Soluciones para cada negocio",
    "heroSubtitle": "Descubra cómo Woezor puede transformar su negocio de servicios con herramientas potentes diseñadas para ahorrar tiempo, aumentar ingresos y deleitar a sus clientes.",
    "items": {
      "appointments": {
        "title": "Gestión de citas",
        "description": "Optimice su proceso de reservas con nuestro sistema de programación inteligente. Reduzca las ausencias y maximice la eficiencia de su calendario.",
        "features": {
          "portal": "Portal de reservas en línea",
          "reminders": "Recordatorios automatizados",
          "sync": "Sincronización de calendario",
          "recurring": "Citas recurrentes"
        }
      },
      "customers": {
        "title": "Gestión de clientes",
        "description": "Fortalezca sus relaciones con los clientes. Haga seguimiento de interacciones, preferencias e historial en un solo lugar.",
        "features": {
          "profiles": "Perfiles de clientes",
          "history": "Historial de interacciones",
          "notes": "Notas y etiquetas",
          "segmentation": "Segmentación"
        }
      },
      "analytics": {
        "title": "Analítica e información",
        "description": "Tome decisiones basadas en datos con analítica integral. Comprenda el rendimiento de su negocio de un vistazo.",
        "features": {
          "revenue": "Seguimiento de ingresos",
          "trends": "Tendencias de reservas",
          "insights": "Información de clientes",
          "reports": "Informes personalizados"
        }
      },
      "payments": {
        "title": "Procesamiento de pagos",
        "description": "Acepte pagos sin complicaciones. Múltiples métodos de pago, facturación automática y seguimiento financiero.",
        "features": {
          "methods": "Múltiples métodos de pago",
          "invoicing": "Facturación automática",
          "reminders": "Recordatorios de pago",
          "reports": "Informes financieros"
        }
      },
      "notifications": {
        "title": "Notificaciones y alertas",
        "description": "Mantenga a todos informados. Notificaciones automatizadas para citas, actualizaciones y eventos importantes.",
        "features": {
          "email": "Notificaciones por correo",
          "sms": "Recordatorios por SMS",
          "push": "Notificaciones push",
          "triggers": "Disparadores personalizados"
        }
      },
      "security": {
        "title": "Seguridad y cumplimiento",
        "description": "Sus datos están seguros con nosotros. Seguridad de nivel empresarial y cumplimiento de estándares de la industria.",
        "features": {
          "encryption": "Cifrado de datos",
          "access": "Acceso basado en roles",
          "audit": "Registros de auditoría",
          "gdpr": "Cumple con GDPR"
        }
      }
    },
    "industriesTitle": "Diseñado para su industria",
    "industriesSubtitle": "Ya sea un profesional independiente o gestione varias ubicaciones, Woezor se adapta a sus necesidades específicas.",
    "industries": {
      "healthcare": {
        "title": "Salud",
        "description": "Consultorios médicos, clínicas y proveedores de salud"
      },
      "beauty": {
        "title": "Belleza y bienestar",
        "description": "Salones, spas y centros de bienestar"
      },
      "professional": {
        "title": "Servicios profesionales",
        "description": "Consultores, abogados y contadores"
      },
      "fitness": {
        "title": "Fitness",
        "description": "Gimnasios, entrenadores personales y estudios de fitness"
      },
      "education": {
        "title": "Educación",
        "description": "Tutores, coaches y centros de formación"
      },
      "home": {
        "title": "Servicios del hogar",
        "description": "Limpieza, reparaciones y mantenimiento"
      }
    },
    "ctaTitle": "¿Listo para transformar su negocio?",
    "ctaSubtitle": "Únase a miles de negocios que ya usan nuestra plataforma para crecer.",
    "startTrial": "Iniciar prueba gratuita",
    "contactSales": "Contactar ventas"
  },
  "contact": {
    "heroTitle": "Póngase en contacto",
    "heroSubtitle": "¿Tiene preguntas sobre Woezor? ¿Quiere ver una demo? Nuestro equipo está aquí para ayudarle a encontrar la solución perfecta para su negocio.",
    "formTitle": "Envíenos un mensaje",
    "formDescription": "Complete el formulario a continuación y nos pondremos en contacto lo antes posible.",
    "name": "Nombre",
    "email": "Correo electrónico",
    "company": "Empresa",
    "message": "Mensaje",
    "namePlaceholder": "Su nombre",
    "emailPlaceholder": "usted@ejemplo.com",
    "companyPlaceholder": "Su empresa (opcional)",
    "messagePlaceholder": "¿Cómo podemos ayudarle?",
    "send": "Enviar mensaje",
    "sending": "Enviando...",
    "success": "¡Mensaje enviado! Nos pondremos en contacto pronto.",
    "errors": {
      "nameRequired": "El nombre es obligatorio",
      "emailRequired": "El correo es obligatorio",
      "emailInvalid": "Ingrese un correo electrónico válido",
      "messageRequired": "El mensaje es obligatorio"
    },
    "infoTitle": "Información de contacto",
    "infoSubtitle": "Contáctenos a través de cualquiera de estos canales.",
    "channels": {
      "email": {
        "title": "Correo electrónico",
        "description": "Nuestro equipo responderá en un plazo de 24 horas"
      },
      "phone": {
        "title": "Teléfono",
        "description": "Lun-Vie de 8:00 a 18:00"
      },
      "office": {
        "title": "Oficina",
        "description": "Visítenos"
      },
      "hours": {
        "title": "Horario",
        "description": "Horario de atención",
        "value": "Lun - Vie: 8:00 - 18:00"
      }
    },
    "faqTitle": "Preguntas frecuentes",
    "faqDescription": "¿Busca respuestas rápidas? Consulte nuestra sección de preguntas frecuentes sobre precios, funciones y cómo comenzar.",
    "viewFaq": "Ver preguntas frecuentes →"
  },
  "developers": {
    "badge": "Plataforma para desarrolladores",
    "heroTitle": "Desarrolle con la API de Woezor",
    "heroSubtitle": "Integre programación de citas, gestión de clientes y más en sus aplicaciones con nuestra potente API y herramientas para desarrolladores.",
    "viewDocs": "Ver documentación",
    "getApiKeys": "Obtener claves API",
    "featuresTitle": "Diseñado para desarrolladores",
    "featuresSubtitle": "Todo lo que necesita para integrar Woezor en sus aplicaciones.",
    "features": {
      "rest": {
        "title": "API RESTful",
        "description": "API REST limpia y bien documentada para una integración fluida con sus sistemas existentes."
      },
      "oauth": {
        "title": "OAuth 2.0",
        "description": "Autenticación segura usando el protocolo OAuth 2.0 estándar de la industria."
      },
      "json": {
        "title": "Respuestas JSON",
        "description": "Formato de respuesta JSON consistente con manejo integral de errores."
      },
      "webhooks": {
        "title": "Webhooks",
        "description": "Notificaciones de eventos en tiempo real para mantener sus sistemas sincronizados."
      },
      "rateLimit": {
        "title": "Límite de tasa",
        "description": "Políticas de uso justo con límites generosos para todos los planes."
      },
      "uptime": {
        "title": "99,9% de disponibilidad",
        "description": "Infraestructura confiable con garantías de alta disponibilidad."
      }
    },
    "codeTitle": "Simple e intuitivo",
    "codeSubtitle": "Comience en minutos con nuestro diseño de API limpio. Cree citas, gestione clientes y acceda a analítica con solo unas líneas de código.",
    "steps": {
      "signup": {
        "title": "Regístrese para obtener una cuenta",
        "description": "Cree su cuenta gratuita de desarrollador"
      },
      "keys": {
        "title": "Obtenga sus claves API",
        "description": "Genere claves desde su panel"
      },
      "build": {
        "title": "Comience a desarrollar",
        "description": "Realice su primera llamada a la API"
      }
    },
    "sdksTitle": "SDKs oficiales",
    "sdksSubtitle": "Use nuestros SDKs oficiales para integrar Woezor en su lenguaje favorito.",
    "sdkStatus": {
      "stable": "estable",
      "beta": "beta",
      "coming": "próximamente"
    },
    "ctaTitle": "¿Listo para comenzar a desarrollar?",
    "ctaSubtitle": "Cree su cuenta gratuita y obtenga sus claves API en minutos.",
    "getStarted": "Comenzar gratis",
    "talkToSales": "Hablar con ventas"
  }
}
